import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import DrawerButton from '../DrawerButton';

function UploadAssetButton() {
  const assetUploadManager = store.creative?.assets.uploadManager;

  const showUploadAssetModal = () => {
    if (assetUploadManager) assetUploadManager.modalVisible = true;
  };

  return (
    <DrawerButton disabled={!assetUploadManager} onClick={showUploadAssetModal}>
      Upload
    </DrawerButton>
  );
}

export default observer(UploadAssetButton);
